import React from "react"
import {
	BeneficialOwner,
	BeneficialOwnerResource,
	updateBeneficialOwnerDeprecated,
} from "../../resources/beneficialOwner"
import EditBeneficialOwnerModal, {UpdateBeneficialOwnerFn} from "./EditBeneficialOwnerModal"
import {parsePhoneNumber} from "libphonenumber-js"
import moment from "moment"

interface EditApplicationBeneficialOwnerModalProps {
	bo: BeneficialOwnerResource
	close: () => void
	refresh: () => void
}

export default function EditApplicationBeneficialOwnerModal({
	bo,
	close,
	refresh,
}: EditApplicationBeneficialOwnerModalProps) {
	const updateApplicationBeneficialOwner: UpdateBeneficialOwnerFn = async (accessToken, values) => {
		const updatedPhone = parsePhoneNumber(values.phone)
		const attributes: BeneficialOwner = {
			fullName: {first: values.firstName, last: values.lastName},
			email: values.email,
			address: {
				postalCode: values.postalCode,
				street: values.street,
				street2: values.street2,
				state: values.state,
				city: values.city,
				country: values.country,
			},
			phone: {
				countryCode: updatedPhone.countryCallingCode.toString(),
				number: updatedPhone.nationalNumber.toString(),
			},
			dateOfBirth: moment(values.dateOfBirth, "YYYY-MM-DD").toDate(),
			ssn: values.identificationType === "ssn" ? values.ssn : undefined,
			passport: values.identificationType === "passport" ? values.passport : undefined,
			nationality: ["passport", "ssn"].includes(values.identificationType) ? values.nationality : undefined,
			matriculaConsular: values.identificationType === "matriculaConsular" ? values.matriculaConsular : undefined,
			percentage: values.percentage ? +values.percentage : undefined,
			status: bo.attributes.status,
		}

		return updateBeneficialOwnerDeprecated(accessToken, {
			id: bo.id,
			type: "beneficialOwner",
			attributes,
			relationships: bo.relationships,
		})
	}

	return (
		<EditBeneficialOwnerModal
			{...bo.attributes}
			close={close}
			refresh={refresh}
			updateBeneficialOwner={updateApplicationBeneficialOwner}
		/>
	)
}
